import {
  GetAccount200ResponsePositionsInner,
  GetOrderbook200Response,
} from "../../codegen-api";
import { IBaseModalProps } from "../BaseModal";

export enum ClosePositionPageEnum {
  DETAILS,
  REQUEST_RFQ,
}

export interface IClosePositionModal extends IBaseModalProps {
  position?: GetAccount200ResponsePositionsInner;
  orderbook?: GetOrderbook200Response;
}
